// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__JJ0Rh","label":"styles_label__67AAi","icon":"styles_icon__xVlvq"};